import { FunctionKey } from '@WombatTechnology/nitte-time-lib'
import { FormulaUser } from './fs/formulaUser'

export class BookingPageError extends Error {
  constructor(
    public title: string,
    public info: string | null = null,
    public showByBookingPageError: boolean = true
  ) {
    super(title)
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BookingPageError)
    }
    this.name = 'BookingPageError'
  }
}

export class UserNotFoundError extends BookingPageError {
  constructor(readonly userId: string) {
    super('ユーザーが見つかりません', `ユーザーID: ${userId}`)
  }
}

export class PageNotFoundError extends BookingPageError {
  constructor() {
    super('ページが見つかりません。')
  }
}
export class NoAvailablePeriods extends BookingPageError {
  constructor() {
    super('調整できる日時が見つかりません。')
  }
}

export class UnavailableFunctionError extends BookingPageError {
  unavailableFunctionKeys: FunctionKey[]
  constructor(keys: FunctionKey[]) {
    super('このページは現在利用できません。')
    this.unavailableFunctionKeys = keys
  }
}

export class FormulaUserIsNotTeamPlanError extends BookingPageError {
  invalidUsers: FormulaUser[]
  constructor(invalidUsers: FormulaUser[]) {
    super('このページは現在ご利用いただけません。')
    this.invalidUsers = invalidUsers
  }
}

export class InsufficientPermissionError extends BookingPageError {
  constructor(
    readonly userName: string,
    readonly userId: string,
    // カレンダー権限が不足しているユーザー本人のuid (メール通知の宛先解決に使う)
    readonly uid: string
  ) {
    // NOTE: PeriodLoadErrorBoxでhandleしているので、BookingPageErrorでは表示しない。
    super('', '', false)
  }
}

export class OverBookingCountError extends BookingPageError {
  constructor() {
    super('このページは現在ご利用いただけません。')
  }
}

export class TeamTrialEndedError extends BookingPageError {
  constructor() {
    super('このページは現在ご利用いただけません。')
  }
}
